import React, { } from 'react';
import {  Navigate } from 'react-router-dom';


export  const JiangoilRoutes=[
      {
            path:'/',
            lazyComponent:()=>import('./MainPage'),
            root:true,
            children:[
                  {
                        path:'/home',
                        lazyComponent:()=>import('./HomePage'),
                  },
                  {
                        path:'/farm',
                        lazyComponent:()=>import('./FarmPage'),
                  },
                  {
                        path:'/about',
                        lazyComponent:()=>import('./AboutPage'),
                  },
                  {
                        path:'/new',
                        lazyComponent:()=>import('./NewPage'),
                  },
                  {
                        path:'/coop',
                        lazyComponent:()=>import('./CoopPage'),
                  },
                  {
                        path:'/contact',
                        lazyComponent:()=>import('./ContactPage'),
                  },
                  {
                        path:'/services',
                        lazyComponent:()=>import('./ServicesPage'),
                  },
                  {
                        path:'/',
                        component:<Navigate to="/home" replace />,
                  },
            ]
      },
      {
            path:'/article/:id',
            lazyComponent:()=>import('./ArticlePage'),
      },
      {
            path:'/sitemap',
            lazyComponent:()=>import('./views/SitemapView'),
      },
      {
            path:'/search',
            lazyComponent:()=>import('./views/SearchPage'),
      },
];
